import React, { useState, useEffect, useContext } from "react";
import { Modal, Text, Button, Icon, Checkbox, Loader} from "@ui-component-library";
import { ContentContainer } from "./utils/utils";

export const ForestRequirementStep = ({ currentStepIndex, handleNext, arbonicsData, updateCo2Deal}) => {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const area = arbonicsData.sbo?.arbonics?.ha ?? arbonicsData.sbo?.data?.arbonics?.ha ?? 0;
  const formattedArea = Number(area).toLocaleString();

  const price = arbonicsData.sbo?.arbonics?.price ?? arbonicsData.sbo?.data?.arbonics?.price ?? 0;
  const formattedPrice = Number(price).toLocaleString();

  const handleSubmit = async () => {
      setIsLoading(true)
      if (arbonicsData.selectedProp.dfr){
        await updateCo2Deal({
          stage:"arbonics",
          comments: "sent to arbonics"
        })

        gtag("event", "fe_co2_success" + currentStepIndex.toString(), {
          method: "site"
        });
        handleNext({
          arbonicsData: {  },
        });
      }
      else{
        window.location.href = "/min-skog/?view=overvakning"
      }
    
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Text variant="bodyMediumBaseRegular">
          Vänta...
        </Text>
        <Loader />
      </div>
    );
  }

  return (
    <>
      <Modal.Content>
        <ContentContainer>
          <Text variant="subheaderSmallMedium">Grattis! Din fastighet ser ut att uppfylla kraven för kolkrediter.</Text>
          {arbonicsData.selectedProp.dfr?<> <Text variant="bodySmallRegular" className="neutral-pebble">Din skog uppfyller de grundläggande kriterier som krävs för att kunna skickas in till analys.</Text>
          <Text variant="bodySmallRegular" className="neutral-pebble"> Det betyder att du är ett steg närmare att kunna generera intäkter från dina kolbindande insatser.</Text>
          <Text variant="bodySmallRegular" className="neutral-pebble"> Du har möjlighet att förlänga omloppstiden på cirka <span className="font-medium"> {formattedArea} </span> hektar skog på din fastighet <span className="font-medium">{arbonicsData.selectedProp.designation} </span>och därigenom tjäna kolkrediter – till ett estimerat värde av <span className="font-medium">{formattedPrice} SEK. </span></Text>
          <Text variant="bodySmallRegular" className="neutral-pebble"> Observera att detta är estimerade siffror och att det faktiska värdet kan komma att justeras i samband med offerten.</Text></>:<>
          <Text variant="bodySmallRegular" className="neutral-pebble">En preliminär analys av din Forestand-fil visar att skogen uppfyller de grundläggande kriterier som krävs för att kunna gå vidare till offert.</Text>
          <Text variant="bodySmallRegular" className="neutral-pebble"> Det innebär att du är ett steg närmare att kunna generera intäkter från dina kolbindande åtgärder.</Text>
          <Text variant="bodySmallRegular" className="neutral-pebble"> Analysen tyder på att du har möjlighet att förlänga omloppstiden på cirka <span className="font-medium"> {formattedArea} </span> hektar skog på din fastighet <span className="font-medium">{arbonicsData.selectedProp.designation}, </span>vilket potentiellt kan ge kolkrediter till ett estimerat värde av <span className="font-medium">{formattedPrice} SEK. </span></Text>
          <Text variant="bodySmallRegular" className="neutral-pebble"> Observera att detta endast är en preliminär bedömning. En säkerställd analys kan göras när du köper vår tjänst för skogsövervakning och skickar in ditt intresse.</Text></>}
          <Checkbox name="terms" onClick={(val) => { setAcceptedTerms(val) }}>
            <Text variant="labelMediumRegular">Jag är säker på att planen som är genererad följer verkligheten väl.</Text>
          </Checkbox>
        </ContentContainer>
      </Modal.Content>
      <Modal.Footer>
        <Button
          fullWidth
          variant="primary"
          disabled={!acceptedTerms}
          onClick={handleSubmit}
        >
          {arbonicsData.selectedProp.dfr ? "Nästa steg" : "Köp skogsövervakning"}
          <Icon name="ArrowRightSimple" />
        </Button>
      </Modal.Footer>
    </>
  );
};

